// A blank sweeping interval means "never sweeps", numerically identical to
// an explicit 0 — this always writes all 3 columns rather than trying to
// reproduce a blank-vs-zero distinction from the file (unlike groundwater.ts,
// where that distinction IS real).

import { nextAvailableName } from "./nextAvailableName.ts";
import { parseNum } from "./parseNum.ts";

export interface LandUse {
  name: string;
  sweepingInterval: number;
  sweepingAvailability: number;
  lastSweptDay: number;
}

export function readLandUses(
  raw: ReadonlyMap<string, string[][]>,
  warnings?: Set<string>
): LandUse[] {
  return (raw.get("LANDUSES") ?? [])
    .filter((row) => row[0])
    .map((row) => {
      const ctx = (field: string) => `[LANDUSES] "${row[0]}" ${field}`;
      return {
        name: row[0],
        sweepingInterval: parseNum(row[1], 0, ctx("Sweeping Interval"), warnings),
        sweepingAvailability: parseNum(row[2], 0, ctx("Availability"), warnings),
        lastSweptDay: parseNum(row[3], 0, ctx("Last Swept"), warnings),
      };
    });
}

export function writeLandUses(
  raw: ReadonlyMap<string, string[][]>,
  landUses: LandUse[]
): Map<string, string[][]> {
  const rows = landUses.map((lu) => [
    lu.name,
    String(lu.sweepingInterval),
    String(lu.sweepingAvailability),
    String(lu.lastSweptDay),
  ]);
  const next = new Map(raw);
  next.set("LANDUSES", rows);
  return next;
}

export function nextAvailableLandUseName(existingNames: Set<string>): string {
  return nextAvailableName(existingNames, "LU");
}
